// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../bindings/bao-searcher";
import "./../bindings/bao-number-box";
import BaseViewModel from "./../factories/base-view-model2";
import BaoDialog from "./../factories/bao-dialog";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import appTabController from "./../services/app-tab-controller";
import baoMenu from "./../services/bao-menu";
import * as moment from "moment";
class SummaryReportFilter extends BaseViewModel {
    SummaryReportFilterTab: TabPage;
    SummaryReportRoleTab: TabPage;
    SummaryReportId: KnockoutObservable<string> = ko.observable();
    Name: KnockoutObservable<string> = ko.observable();
    UserId: KnockoutObservable<string> = ko.observable();
    Username: KnockoutObservable<string> = ko.observable();
    FilterIntervalId: KnockoutObservable<string> = ko.observable();
    FilterIntervalName: KnockoutObservable<string> = ko.observable();
    FilterInterval: KnockoutObservable<number> = ko.observable();
    FilterIntervalStartDay: KnockoutObservable<number> = ko.observable();
    FilterIntervalEndDay: KnockoutObservable<number> = ko.observable();
    FilterIntervalStartTime: KnockoutObservable<any> = ko.observable();
    FilterIntervalEndTime: KnockoutObservable<any> = ko.observable();
    ListReportLayoutAvailableReportId: KnockoutObservable<string> = ko.observable();
    ListReportLayoutAvailableReportName: KnockoutObservable<string> = ko.observable();
    ListReportLayoutId: KnockoutObservable<string> = ko.observable();
    ListReportLayoutName: KnockoutObservable<string> = ko.observable();
    ShowNumberBoxFilterInterval = ko.computed(() => {
        if (this.FilterIntervalId()?.toLocaleLowerCase() != '9df64360-3c66-4ec0-b475-34aa0636866d') {
            return (true);
        }
        else {
            return (false);
        }
    });
    UserSearcher: Bindings.baoSearcher = {
        SearchType: "Uadm-User",
        ObjectId: this.UserId,
        ObjectValue: "Username",
        AutoComplete: true,
        AutoSearch: true
    };
    FilterIntervalSearcher: Bindings.baoSearcher = {
        SearchType: "TimeUnit",
        ObjectId: this.FilterIntervalId,
        ObjectValue: "Name",
        AutoComplete: true,
        AutoSearch: true
    };
    FilterIntervalDateTimePickerStartTime: Bindings.baoDateTimePicker = {
        value: this.FilterIntervalStartTime,
        mode: "time"
    }
    FilterIntervalDateTimePickerEndTime: Bindings.baoDateTimePicker = {
        value: this.FilterIntervalEndTime,
        mode: "time"
    }
    NumberBoxFilterInterval: Bindings.baoNumberBox = {
        value: this.FilterInterval,
        decimalDigits: 0,
        thousandSeperator: false,
        culture: Bao.Session.Language.Symbol()
    };
    NumberBoxFilterIntervalStartDay: Bindings.baoNumberBox = {
        value: this.FilterIntervalStartDay,
        decimalDigits: 0,
        thousandSeperator: false,
        culture: Bao.Session.Language.Symbol()
    };
    NumberBoxFilterIntervalEndDay: Bindings.baoNumberBox = {
        value: this.FilterIntervalEndDay,
        decimalDigits: 0,
        thousandSeperator: false,
        culture: Bao.Session.Language.Symbol()
    };
    ReportLayoutSearcherList: Bindings.baoSearcher = {
        SearchType: "ReportLayout",
        ObjectId: this.ListReportLayoutId,
        ObjectValue: "Name",
        AutoComplete: true,
        AutoSearch: true
    };
    ReportLayoutAvailableReportSearcherList: Bindings.baoSearcher = {
        SearchType: "ReportLayoutAvailableReport",
        ObjectId: this.ListReportLayoutAvailableReportId,
        ObjectValue: "ReportLayoutName",
        AutoComplete: true,
        AutoSearch: true,
        CustomFilter: { ReportLayoutId: this.ListReportLayoutId }
    };
    constructor(tabPage: TabPage) {
        super(tabPage);
    }
    InitUrl() {
        return "SummaryReportFilter/Init";
    }
    init() {
        this.FilterIntervalId.subscribe(() => {
            this.PrefillIntervalData();
        });
        return $.when(super.init(), super.InitTabController()).then(() => {
            baoMenu.registerEvent((action) => { this.MenuClick(action); });
            this.loadTabs();
        });
    }
    MenuClick = (action) => {
        if (this.TabPage.IsActiveTab()) {
            switch (action.ActionKey()) {
                case "SummaryReportFilterCopy":
                    this.CopySummaryReport();
                    this.TabPage.IsLoading(false);
                    break;
            }
        }
    };
    CopySummaryReport() {
        this.TabPage.IsLoading(true);
        return Bao.post("SummaryReportFilter/Copy", JSON.stringify({ model: ko.map.toJS(this, true) }), function (value) {
            var summaryReportId = value.NewSummaryReportId;
            //self.CopyRoleTabs(roleId);
            ////Alle Tabs durchlaufen und Copy-Funktion aufrufen
            //self.TabViewModel.SaveTabs(value.Result).then(function () {
            //    tabPage.DirtyFlag(false);
            //    self.PerformRefresh();
            //});
            var newTab = new TabPage();
            newTab.Url("SummaryReportFilter/Index");
            newTab.UrlData({ id: summaryReportId });
            newTab.ObjectId(summaryReportId);
            appTabController.AddTab(newTab);
            //tabPage.IsLoading(false);
        });
        //var newTab = new TabPage();
        //newTab.UrlData({ id: this.SummaryReportId() });
        //newTab.Url("SummaryReportFilter/Copy");
        //appTabController.AddTab(newTab);
    }
    private loadTabs = () => {
        this.SummaryReportFilterTab = new TabPage();
        this.SummaryReportFilterTab.IsClosable(false);
        this.SummaryReportFilterTab.Url("SummaryReportFilterTab");
        this.SummaryReportFilterTab.AutoSelect = true;
        this.TabController.AddTab(this.SummaryReportFilterTab);

        this.SummaryReportRoleTab = new TabPage();
        this.SummaryReportRoleTab.IsClosable(false);
        this.SummaryReportRoleTab.Url("SummaryReportRoleTab");
        this.SummaryReportRoleTab.AutoSelect = false;
        this.TabController.AddTab(this.SummaryReportRoleTab);
    };
    // Prefill interval data on load if they are null or undefined
    PrefillIntervalData() : void {
        if (this.FilterIntervalStartDay() === null || this.FilterIntervalStartDay() === undefined){
            this.FilterIntervalStartDay(0);
        }
        if (this.FilterIntervalEndDay() === null || this.FilterIntervalEndDay() === undefined){
            this.FilterIntervalEndDay(0);
        }
        if (this.FilterIntervalStartTime() === null || this.FilterIntervalStartTime() === undefined || this.FilterIntervalStartTime().length < 4){
            this.FilterIntervalStartTime("00:00");
        }
        if (this.FilterIntervalEndTime() === null || this.FilterIntervalEndTime() === undefined || this.FilterIntervalEndTime().length < 4){
            this.FilterIntervalEndTime("23:59");
        }
    }
    // Check if the entered interval data is correct
    // Start date has to be before end date
    IntervalSettingCheck(): boolean{
        let startDay: number = -(this.FilterIntervalStartDay() >>> 0);
        let startTime = this.FilterIntervalStartTime().split(':');
        let endDay: number = -(this.FilterIntervalEndDay() >>> 0);
        let endTime = this.FilterIntervalEndTime().split(':');
        let start: any = moment()
            .add(startDay, "day").hour(startTime[0]).minute(startTime[1]).second(0).millisecond(0)
            .format(Bao.Utils.DateTimeFormat);
        let end: any = moment()
            .add(endDay, "day").hour(endTime[0]).minute(endTime[1]).second(0).millisecond(0)
            .format(Bao.Utils.DateTimeFormat);

        return moment(start, Bao.Utils.DateTimeFormat).isBefore(moment(end, Bao.Utils.DateTimeFormat));
    }
    CompleteCheck() {
        let isComplete = true;
        let correctIntervalSetting = true;
        if (Bao.Utils.String.IsNullOrEmpty(this.Name()) || Bao.Utils.String.IsNullOrEmpty(this.FilterIntervalId())) {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrEmpty(this.FilterIntervalId())) {
            isComplete = false;
        }
        if (this.ShowNumberBoxFilterInterval() && (this.FilterInterval() === null || this.FilterInterval() === undefined)) {
            isComplete = false;
        }
        if (!this.ShowNumberBoxFilterInterval()) {
            if (this.FilterIntervalStartDay() === null || this.FilterIntervalStartDay() === undefined
                || this.FilterIntervalEndDay() === null || this.FilterIntervalEndDay() === undefined) {
                isComplete = false;
            } else if (this.FilterIntervalStartTime === null || this.FilterIntervalStartTime === undefined
                || this.FilterIntervalEndTime === null || this.FilterIntervalEndTime === undefined){
                isComplete = false;
            } else {
                correctIntervalSetting = this.IntervalSettingCheck();
            }
        }
        if(!isComplete){
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        } else if(!correctIntervalSetting){
            isComplete = false;
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgIncorrectIntervalSetting"), "info");
        }
        return isComplete;
    }
}
export default SummaryReportFilter;